import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TranslocoModule } from '@ngneat/transloco';
import { FailedMessage, SaveMessage, SuccessMessage } from 'app/model/message.constant';
import { AttendanceService } from 'app/services/attendanceService/attendance.service';
import { GF } from 'app/shared/global-functions';
import { AuthService } from 'app/services/authService/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-bundy',
    templateUrl: './bundy.component.html',
    styleUrls: ['./bundy.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatMenuModule,
        TranslocoModule
      ],
})
export class BundyComponent implements OnInit {
    ishide = true
    bundyy: string = ''
    failedMessage = { ...FailedMessage }
    saveMessage = { ...SaveMessage }
    successMessage = { ...SuccessMessage }
    //bundy
    is_webBreak = true;
    constructor(
        public auth: AuthService,
        private message: FuseConfirmationService,
        private attendanceService: AttendanceService) { }

    ngOnInit() {
        this.is_webBreak = (sessionStorage.getItem('is_webBreak') == "true")
    }

    bundy(bundy: number) {
        const obj = { bundy, bundyType: 0 };

        const api =
            GF.IsEmptyReturn(localStorage.getItem('bt'), 0) == 0
                ? 'postBundy'
                : 'postQueBundy';

        this.attendanceService[api](obj).subscribe({
            next: (res: any) => {
                if (res.statusCode === 200) {
                    this.bundyy = this.getBundyText(bundy);
                    this.successMessage.title = this.bundyy;
                    this.successMessage.message = res.message;
                    this.message.open(this.successMessage);
                }
            },
            error: (e) => {
                this.message.open(this.failedMessage);
                console.error(e);
            }
        });
    }

    bundyNotification(bundy: number) {
        const text = this.getBundyText(bundy);

        this.saveMessage.title = text;
        this.saveMessage.message = `Are you sure you want to ${text}?`;

        this.message.open(this.saveMessage)
            .afterClosed()
            .subscribe(result => {
                if (result !== 'confirmed') return;

                this.attendanceService.postBundyNotification({
                    bundy,
                    bundyType: 0
                }).subscribe({
                    next: (res: any) => {
                        if (res.statusCode === 200) {
                            this.bundy(bundy);
                        } else {
                            this.saveMessage.title = `Multiple ${text} Detected`;
                            this.saveMessage.message = res.message;

                            this.message.open(this.saveMessage)
                                .afterClosed()
                                .subscribe(r => {
                                    if (r === 'confirmed') {
                                        this.bundy(bundy);
                                    }
                                });
                        }
                    },
                    error: () => this.message.open(this.failedMessage)
                });
            });
    }

    getBundyText(bundy: number): string {
        switch (bundy) {
            case 0: return 'Clock In';
            case 1: return 'Clock Out';
            case 2: return 'Break Start';
            case 3: return 'Break End';
            default: return '';
        }
    }

}
